module.exports = __webpack_public_path__ + "static/img/irole.cfc08ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/ch/irole.png
// module id = oOSM
// module chunks = 7